import { useQuery } from '@tanstack/react-query';

import { versionQueries } from '../../api/versionQueries';

/*
 * `enabled` narrows the query further, it never widens it: without a
 * configured API there is no backend to ask, and the footer only asks
 * while it shows the answer.
 */
export function useBackendVersion({ enabled = true } = {}) {
  const options = versionQueries.backend();
  return useQuery({ ...options, enabled: options.enabled && enabled });
}
